module.exports = __webpack_public_path__ + "static/HipPull-Deadlift-5fc5995a79c398990c0e8efc443796e7.mp4";